import React from "react";

interface Props {
  children?: React.ReactNode;
  active: boolean;
  onClick?: () => void;
}

const Modal: React.FC<Props> = ({ active, children, onClick }) => {
  return (
    <>
      {active && (
        <div className="fixed inset-0 z-[200]">
          {/* Затемнённый фон */}
          <div className="fixed inset-0 bg-black opacity-30 z-40" />

          {/* Контейнер модалки */}
          <div
            data-testid="modal-backdrop"
            onClick={onClick}
            className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 overflow-y-auto"
          >
            <div
              role="dialog"
              aria-modal="true"
              className="relative z-[100] bg-white text-left shadow-xl transition-all rounded-md w-full max-w-[640px] max-h-[calc(100dvh-2rem)] h-auto sm:w-auto overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Кнопка закрытия */}
              <div className="w-full flex justify-end pr-3 pt-4">
                <button
                  onClick={onClick}
                  type="button"
                  aria-label="Закрити"
                  className="ms-auto -my-1.5 inline-flex items-center justify-center h-8 w-8 hover:opacity-70"
                >
                  <svg
                    className="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                </button>
              </div>

              {/* Контент модалки */}
              <div className="p-4">{children}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
